import { forwardRef } from "react";

const IconComponent = forwardRef((props, ref) => {
    return (
        <p ref={ref} {...props}>
            {props.icon}
        </p>
    );
});

IconComponent.displayName = "IconComponent";
export default IconComponent;
